/** Valeurs stockées en BDD (enum legacy family_members.relationship). */
export const FAMILY_RELATIONSHIP_OPTIONS = [
  { value: "spouse", label: "Conjoint(e)" },
  { value: "child", label: "Enfant" },
] as const;

export type FamilyRelationshipValue = (typeof FAMILY_RELATIONSHIP_OPTIONS)[number]["value"];

export function formatFamilyRelationship(value: string | null | undefined): string {
  const raw = (value ?? "").trim().toLowerCase();
  if (!raw) return "—";
  const hit = FAMILY_RELATIONSHIP_OPTIONS.find((o) => o.value === raw);
  if (hit) return hit.label;
  if (raw === "conjoint" || raw === "époux" || raw === "epoux" || raw === "épouse" || raw === "epouse") {
    return "Conjoint(e)";
  }
  if (raw === "enfant" || raw === "fils" || raw === "fille") {
    return "Enfant";
  }
  return value || "—";
}
